import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { getUserInfo, checkMessageIsRead, login } from '@/api'
export interface UserState {
  isLogin: boolean;
  realName: string;
  gender: number | null;
  roles: any[];
  departments: any[];
  messageNum: number | null;
}
@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements UserState {
  public messageNum = null;
  public isLogin = false
  public realName = '测试人'
  public gender: number | null = null
  public roles: any[] = []
  public departments: any[] = []

  @Mutation
  private SET_NAME (data: string) { this.realName = data }

  @Mutation
  private SET_GENDER (data: number) { this.gender = data }

  @Mutation
  private SET_ROLE (data: any[]) { this.roles = data }

  @Mutation
  private SET_DEPARTMENT (data: any[]) { this.departments = data }

  @Mutation
  private SET_MESSAGEISREAD (data: any) { this.messageNum = data.messageNum }

  @Mutation
  private SET_ISLOGIN (data: any) { this.isLogin = data }

  @Action
  public async GetMessageIsRead () {
    const result: any = await checkMessageIsRead({})
    this.SET_MESSAGEISREAD(result)
  }

  @Action({ rawError: true })
  public async GetUserInfo () {
    const { realName, department, eduRole: role }: any = await getUserInfo({})
    this.SET_NAME(realName)
    this.SET_DEPARTMENT([department])
    // this.SET_ROLE(['超级管理员'])
    this.SET_ROLE([role])
  }
}

export const UserModule = getModule(User)
